import {
  Button,
  ButtonVariant,
  InputGroup,
  TextInput,
  ToolbarFilter,
} from '@patternfly/react-core'
import { SearchIcon } from '@patternfly/react-icons'
import * as React from 'react'
import { useCallback, useMemo } from 'react'

import { FilterCategories, FilterLabels } from './filters'

interface Props {
  patientName: string
  showToolbarItem: boolean
  onPatientNameUpdated: (patientName?: string) => void
}

export const PatientNameToolbarFilter = ({
  patientName,
  onPatientNameUpdated,
  showToolbarItem,
}: Props) => {
  const onChange = useCallback(
    (value: string) => {
      onPatientNameUpdated(value)
    },
    [onPatientNameUpdated],
  )

  const onDelete = useCallback(() => {
    onPatientNameUpdated(null)
  }, [onPatientNameUpdated])

  const patientNameChips = useMemo(() => {
    return patientName ? [patientName] : []
  }, [patientName])

  return (
    <ToolbarFilter
      chips={patientNameChips}
      deleteChip={onDelete}
      categoryName={FilterLabels[FilterCategories.PatientName]}
      showToolbarItem={showToolbarItem}
    >
      <InputGroup>
        <TextInput
          name="patientNameInput"
          id="patientNameInput"
          type="search"
          aria-label="patient name filter input"
          onChange={onChange}
          value={patientName ? patientName : ''}
          placeholder="Filter by Patient Name..."
        />
        <Button
          variant={ButtonVariant.control}
          aria-label="search button for patient name filter input"
        >
          <SearchIcon />
        </Button>
      </InputGroup>
    </ToolbarFilter>
  )
}
